import axios from 'axios';
import authHeader from './auth-header';

const API_URL = process.env.VUE_APP_API_BASE_URL;

async function getStats(params) {
  const response = await axios.get(`${API_URL}/backoffice/dashboard`, { params: params, headers: authHeader() });
  return response.data;
}

export default {
  getStats
};